import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input, OnChanges, OnInit,
    Output, SimpleChanges
} from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { AdaptiveRule } from './state/adaptive-rule.model';
import { AdaptiveRulesService } from './state/adaptive-rules.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs/Subscription';
import { Store } from '@ngrx/store';

@Component({
    selector: 'rule-entry-table',
    templateUrl: './rule-entry-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RuleEntryTableComponent implements OnChanges, OnInit {

    @Output() readonly defaultChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() readonly mapChanged: EventEmitter<AdaptiveRule> = new EventEmitter<AdaptiveRule>();

    @Input() rule;
    @Input() reference;
    @Input() referenceTypes;
    @Input() locations;
    @Input() reasons;
    @Input() appointmentResources;
    @Input() locationEntities;
    @Input() providers;
    @Input() ruleName;
    @Input() defaultRuleValue;
    @Input() selectedUserId;
    @Input() mediaType;
    @Input() dayOfWeek;
    name: string;
    referenceKey: string;

    updatedRule: AdaptiveRule = {
        ruleName: '',
        referenceKey: '',
        description: ' ',
        default: undefined,
        reference: undefined,
        mediaType: '',
        type: 'map'
    };

    viewModel$: Observable<any>;
    ruleEntries: Array<any> = new Array<any>();
    subscription = new Subscription();

    ngOnInit(): void {
        if (this.updatedRule.map === undefined) {
            this.updatedRule.map = [];
        }
    }

    constructor(private adaptiveRulesService: AdaptiveRulesService,
                private modalService: BsModalService,
                private store: Store<any>) {
    }

    onEditSave(rule): void {
        if (rule.defaultFlag) {
            this.defaultChanged.emit(rule.expandedValue);
        }


        const expandedValue = this.mediaType !== undefined && this.mediaType === 'voice' ?( rule.expandedValue !== undefined && rule.expandedValue !== null ? rule.expandedValue.toString() : rule.expandedValue)  : rule.expandedValue;
        const updateRule: any = {[rule.shortValue] : expandedValue};

        this.updatedRule.reference = this.reference;
        this.updatedRule.referenceKey = this.referenceKey;
        this.updatedRule.ruleName = this.ruleName;
        const defaultValue = this.defaultRuleValue !== undefined && this.defaultRuleValue !== null ? this.defaultRuleValue.toString() : undefined;
        this.updatedRule.default = rule.defaultFlag ? expandedValue : defaultValue;
        this.updatedRule.mediaType = this.mediaType;

        if (this.updatedRule.map !== undefined) {
            const index = this.updatedRule.map.findIndex(ruleEntry => Object.keys(ruleEntry)[0] === rule.shortValue);

            if (index === -1) {
                if (rule.expandedValue !== '' && rule.expandedValue !== undefined) {
                    this.updatedRule.map.push(updateRule);
                }
            } else {
                if (rule.expandedValue === '' || rule.expandedValue === undefined || rule.expandedValue === null) {
                    this.updatedRule.map.splice(index, 1);
                } else {
                    if (Object.values(this.updatedRule.map[index])[0] === null
                        || Object.values(this.updatedRule.map[index])[0].toString() !== expandedValue) {
                        this.updatedRule.map.splice(index, 1);
                        this.updatedRule.map.push(updateRule);
                    }
                }

            }
        } else {
            if (rule.expandedValue !== '' && rule.expandedValue !== undefined) {
                this.updatedRule.map = [];
                this.updatedRule.map.push(updateRule);
            }
        }

        this.mapChanged.emit(this.updatedRule);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.rule !== undefined) {
           if (this.selectedUserId !== undefined && this.selectedUserId !== 0) {
            this.updatedRule = {
                ruleName: '',
                referenceKey: '',
                description: ' ',
                default: undefined,
                reference: undefined,
                mediaType: undefined,
                type: 'map'
            };
           }

           const updatedRule: any = {...this.updatedRule};
           if (updatedRule.map === undefined || updatedRule.map === null) {
                updatedRule.map = [];
            }
           updatedRule.reference = this.reference;
           updatedRule.description = ' '; // TODO: add description as input instead
           updatedRule.ruleName = this.ruleName;
           updatedRule.default = this.defaultRuleValue;
           updatedRule.mediaType = this.mediaType;

           if (this.rule.map !== undefined && this.rule.map !== null) {
                this.rule.map.forEach(entry => updatedRule.map.push(entry));
            }

           this.updatedRule = updatedRule;
           this.updateRuleEntries();
        }

        if (changes.reference !== undefined) {
            this.updateRuleEntries();
        }

        if (changes.mediaType !== undefined && !changes.mediaType.isFirstChange()) {
            this.updateRuleEntries();
        }

        if (changes.defaultRuleValue !== undefined) {
            this.ruleEntries.forEach(rule => {
                if (rule.expandedValue !== this.defaultRuleValue && rule.defaultFlag) {
                    rule.defaultFlag = false;
                }
            });
            if (changes.rule === undefined
                && !changes.defaultRuleValue.firstChange) {
                this.updatedRule.referenceKey = this.referenceKey;
                this.updatedRule.default = this.defaultRuleValue;
                this.mapChanged.emit(this.updatedRule);
            }
        }

        if (changes.ruleName !== undefined && changes.ruleName.currentValue !== undefined) {
            const updatedRule: any = {...this.updatedRule};
            updatedRule.ruleName = this.ruleName;
            this.updatedRule = updatedRule;
            this.mapChanged.emit(this.updatedRule);
        }
    }

    updateRuleEntries(): void {
        this.name = this.referenceTypes.find(reference => reference.value === this.reference).label;
        this.ruleEntries = [];
        this.setRuleEntry(this.reference);
    }

    updateDefault(value, selectedRule): void {
        if (value) {
            this.onEditSave(selectedRule);
        }
        this.ruleEntries.forEach(rule => {
            if (rule.shortValue !== selectedRule.shortValue && rule.defaultFlag) {
                rule.defaultFlag = false;
            }
        });
    }

    addRuleEntry(ruleVal: any, displayName: any): void {
        const shortValue = ruleVal;
        let expandedValue;

        if (this.rule.listSource !== undefined || this.rule.map !== undefined) {
            const rule = this.rule.map.find(ruleEntry => Object.keys(ruleEntry)[0] === shortValue);
            expandedValue = rule !== undefined ? rule[shortValue] : undefined;
        } else {
            expandedValue = undefined;
        }

        const defaultFlag = this.defaultRuleValue !== undefined && expandedValue === this.defaultRuleValue;
        this.ruleEntries.push({shortValue, expandedValue, defaultFlag, displayName, undefined});
    }

    autoSaveRemovedRule(shortValue): void {
        this.updatedRule.map.splice(this.rule.map.findIndex(rule => Object.keys(rule)[0] === shortValue), 1);
        this.mapChanged.emit(this.updatedRule);
    }

      setRuleEntry(reference): void {
        switch (reference) {
            case 'provider':
                this.referenceKey = 'appointment.providerId';
                if (this.updatedRule !== undefined &&  this.updatedRule.map !== undefined &&  this.updatedRule.map.length > 0) {
                    this.updatedRule.map.forEach(ruleEntry => {
                        const shortValue = Object.keys(ruleEntry)[0];
                        const isValid = this.providers
                            .findIndex(provider => provider.providerId === +shortValue) !== -1;

                        if (!isValid) {
                            this.autoSaveRemovedRule(shortValue);
                        }
                    });
                }
                this.providers.forEach(provider => {
                    this.addRuleEntry(provider.providerId.toString(), provider.providerName + '  ( remoteProviderId: ' + provider.remoteProviderId + ')');
                });
                break;
            case 'reason':
                this.referenceKey = 'appointment.reasonId';
                if (this.updatedRule !== undefined &&  this.updatedRule.map !== undefined &&  this.updatedRule.map.length > 0) {
                    this.updatedRule.map.forEach(ruleEntry => {
                        const shortValue = Object.keys(ruleEntry)[0];
                        const isValid = this.reasons
                            .findIndex(reason => reason.reasonId === +shortValue) !== -1;

                        if (!isValid) {
                            this.autoSaveRemovedRule(shortValue);
                        }
                    });
                }
                this.reasons.forEach(reason => {
                    this.addRuleEntry(reason.reasonId.toString(), reason.reasonName);
                });
                break;
            case 'location':
                this.referenceKey = 'appointment.location';
                if (this.updatedRule !== undefined &&  this.updatedRule.map !== undefined &&  this.updatedRule.map.length > 0) {
                    this.updatedRule.map.forEach(ruleEntry => {
                        const shortValue = Object.keys(ruleEntry)[0];
                        const isValid = this.locations
                            .findIndex(loc => loc === shortValue) !== -1;

                        if (!isValid) {
                            this.autoSaveRemovedRule(shortValue);
                        }
                    });
                }
                this.locations.forEach(loc => {
                    this.addRuleEntry(loc, loc);
                });
                break;
            case 'resource':
                this.referenceKey = 'appointment.resource';
                if (this.updatedRule !== undefined &&  this.updatedRule.map !== undefined &&  this.updatedRule.map.length > 0) {
                    this.updatedRule.map.forEach(ruleEntry => {
                        const shortValue = Object.keys(ruleEntry)[0];
                        const isValid = this.appointmentResources
                            .findIndex(appointmentResource => appointmentResource.resourceName === shortValue) !== -1;

                        if (!isValid) {
                            this.autoSaveRemovedRule(shortValue);
                        }
                    });
                }
                this.appointmentResources.forEach(resources => {
                    this.addRuleEntry(resources.resourceName, resources.resourceName);
                });
                break;
            case 'appointmentLocationId':
                this.referenceKey = 'appointment.locationId';
                if (this.updatedRule !== undefined &&  this.updatedRule.map !== undefined &&  this.updatedRule.map.length > 0) {
                    this.updatedRule.map.forEach(ruleEntry => {
                        const shortValue = Object.keys(ruleEntry)[0];
                        const isValid = this.locationEntities
                           .findIndex(locationEntity => locationEntity.locationId === +shortValue) !== -1;

                        if (!isValid) {
                            this.autoSaveRemovedRule(shortValue);
                        }
                    });
                }
                this.locationEntities.forEach(locationEntity => {
                   this.addRuleEntry(locationEntity.locationId.toString(),
                      `${locationEntity.locationName}  (remoteLocationId: ${locationEntity.remoteLocationId})`);
                });
                break;
            case 'personLocationId':
                this.referenceKey = 'person.locationId';
                if (this.updatedRule !== undefined &&  this.updatedRule.map !== undefined &&  this.updatedRule.map.length > 0) {
                    this.updatedRule.map.forEach(ruleEntry => {
                        const shortValue = Object.keys(ruleEntry)[0];
                        const isValid = this.locationEntities
                           .findIndex(locationEntity => locationEntity.locationId === +shortValue) !== -1;

                        if (!isValid) {
                            this.autoSaveRemovedRule(shortValue);
                        }
                    });
                }
                this.locationEntities.forEach(locationEntity => {
                   this.addRuleEntry(locationEntity.locationId.toString(),
                      `${locationEntity.locationName}  (remoteLocationId: ${locationEntity.remoteLocationId})`);
                });
                break;
            case 'dayOfWeek':
                this.referenceKey = 'templateHelper.dayOfWeek(#dates.createNow(), account)';
                this.dayOfWeek.forEach(day => {
                    this.addRuleEntry( day.value, day.label);
                });
                break;
            case 'dayOfWeekOfAppointment':
                this.referenceKey = 'templateHelper.dayOfWeek(appointment.appointmentTime, account)';
                this.dayOfWeek.forEach(day => {
                    this.addRuleEntry( day.value, day.label);
                });
                break;
            default:
                this.ruleEntries = new Array<any>();
        }
    }

    onKeyDown(event: any): any {
        const keyCode = event.keyCode;
        if (keyCode === 189) {
            event.preventDefault();
            event.stopPropagation();

            return false;
        }

        return;
    }

    updateSoundId(rule: any, event: any): any {
        this.onEditSave(rule);
    }

}
